import React, { Component } from 'react';
import { Link } from 'gatsby';
import classNames from 'classnames';
import PropTypes from 'prop-types';

class Header extends Component {
  constructor(props) {
    super(props);
    const { sticky } = this.props;
    this.state = {
      isOpen: false,
      isSticky: sticky,
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.isActive = this.isActive.bind(this);
  }

  componentDidMount() {
    const { sticky } = this.props;
    if (sticky) {
      return;
    }
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    const { sticky } = this.props;
    if (sticky) {
      return;
    }
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    if (window.pageYOffset >= 200) {
      this.setState({ isSticky: true });
    } else {
      this.setState({ isSticky: false });
    }
  }

  handleClick(e) {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
    e.preventDefault();
  }

  isActive(path) {
    const {
      location: { pathname },
    } = this.props;
    if (path === pathname) {
      return true;
    }

    if (path !== '/' && pathname.includes(path)) {
      return true;
    }

    if (path === '/' && pathname.includes('/room')) {
      return true;
    }

    return false;
  }

  render() {
    // <!-- add class nav-open -->
    const { isOpen, isSticky } = this.state;
    const {
      sticky,
      contacts: {
        email, phone, facebook, instagram, vk,
      },
    } = this.props;
    const classes = classNames('header', {
      'is-sticky': sticky || isSticky,
      'nav-open': isOpen,
    });
    return (
      <header className={classes}>
        <div className="container">
          <div className="header-panel">
            <a className="logo" href="/">
              <span className="logo-item">DOM</span>
              {' YALTA'}
            </a>
            <div className="header-contacts">
              <a href={`mailto:${email}`} className="header-link">
                <span className="header-icon email" />
                {email}
              </a>
              <a href={`tel:${phone}`} className="header-link">
                <span className="header-icon phone" />
                {phone}
              </a>
              <a
                href={facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="header-link social"
              >
                <span className="header-icon facebook" />
              </a>
              <a href={vk} target="_blank" rel="noopener noreferrer" className="header-link social">
                <span className="header-icon vk" />
              </a>
              <a
                href={instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="header-link social"
              >
                <span className="header-icon instagram" />
              </a>
            </div>
            <button type="button" className="hamburger" onClick={this.handleClick}>
              <span className="hamburger-line" />
              <span className="hamburger-line" />
              <span className="hamburger-line" />
            </button>

            <nav className="nav">
              <ul className="nav-list">
                <li className={classNames('nav-item', { 'is-active': this.isActive('/') })}>
                  <Link to="/" className="nav-link">
                    Главная
                  </Link>
                </li>
                <li className={classNames('nav-item', { 'is-active': this.isActive('/about') })}>
                  <Link to="/about/" className="nav-link" activeClassName="is-active">
                    3D Тур
                  </Link>
                </li>
                <li className={classNames('nav-item', { 'is-active': this.isActive('/faq') })}>
                  <Link to="/faq/" className="nav-link" activeClassName="is-active">
                    Вопросы
                  </Link>
                </li>
                <li className={classNames('nav-item', { 'is-active': this.isActive('/reviews') })}>
                  <Link to="/reviews/" className="nav-link">
                    Отзывы
                  </Link>
                </li>
                <li className={classNames('nav-item', { 'is-active': this.isActive('/blog') })}>
                  <Link to="/blog/" className="nav-link">
                    Блог
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </header>
    );
  }
}

Header.propTypes = {
  sticky: PropTypes.bool,
  location: PropTypes.shape().isRequired,
  contacts: PropTypes.shape({
    instagram: PropTypes.string.isRequired,
    facebook: PropTypes.string.isRequired,
    vk: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
  }).isRequired,
};

Header.defaultProps = {
  sticky: false,
};

export default Header;
